import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Link, MessagePlugin, Popconfirm, Space, Table } from 'tdesign-react';
import ListPanel from '@/components/ListPanel';
import useTable from '@/hooks/useTable';
import { deleteDict, getDictList } from '@/services/dictService';
import { renderDateTime, renderTags } from '@/utils/common';
import PermWrapper from '@/components/PermWrapper';
import FormModal from './FormModal';

const { FormItem } = Form;

export default function Dictionary() {
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState();

  const columns = [
    {
      title: '字典名称',
      colKey: 'dictKey',
      cell: renderTags,
      width: 220,
    },
    {
      title: '字典编码',
      colKey: 'dictValue',
      ellipsis: true,
    },
    {
      title: '备注',
      colKey: 'remark',
    },
    {
      title: '创建时间',
      colKey: 'createTime',
      cell: renderDateTime,
      width: 180,
    },
    {
      title: '更新时间',
      colKey: 'updateTime',
      cell: renderDateTime,
      width: 180,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) =>
        row.readOnly ? null : (
          <Space>
            <PermWrapper resource='pulsar:sys:dict:update'>
              <Link
                theme='primary'
                onClick={() => {
                  setDetail(row);
                  setVisible(true);
                }}
                hover='color'
              >
                编辑
              </Link>
            </PermWrapper>
            <PermWrapper resource='pulsar:sys:dict:delete'>
              <Popconfirm theme='danger' content='确定删除？' onConfirm={() => doDelete(row)}>
                <Link theme='danger' hover='color'>
                  删除
                </Link>
              </Popconfirm>
            </PermWrapper>
          </Space>
        ),
      width: 120,
    },
  ];

  const loadData = useMemoizedFn(async (params) => {
    const { data } = await getDictList(params);
    setData(data.items, data.count);
  });

  const { setData, doSearch, config, header, doRefresh } = useTable({
    columns,
    search: (
      <FormItem name='dictKey'>
        <Input clearable placeholder='请输入字典名称' />
      </FormItem>
    ),
    onSearch: loadData,
    remote: true,
    operators: (
      <PermWrapper resource='pulsar:sys:dict:create'>
        <Button onClick={() => setVisible(true)}>新增字典</Button>
      </PermWrapper>
    ),
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  const handleClose = (refresh) => {
    setVisible(false);
    setDetail(null);
    if (refresh) {
      doRefresh();
    }
  };

  const doDelete = async ({ id }) => {
    try {
      await deleteDict(id);
      MessagePlugin.success('删除成功');
      doRefresh();
    } catch (error) {
      console.trace(error);
      throw error;
    }
  };

  return (
    <ListPanel header='数据字典'>
      {header}
      <Table {...config} />
      <FormModal detail={detail} visible={visible} handleClose={handleClose} />
    </ListPanel>
  );
}
